<template>
    <div class="text-end">{{ formatDistance(value) }}</div>
</template>

<script setup lang="ts">
import { $ti } from '@/locize';
import { formatDistance } from '@/utilities/utils';

const props = defineProps<{
    /**
     * The distance to display
     * This is the distance in meters
     */
    value: number | null;
}>();
</script>
